import { getJson } from './http';
import type { CompanySearchResult } from './types';

/** Searches Enhetsregisteret through the site's own API. */
export function searchCompanies(
  name: string,
  includeCoordinates = true,
  signal?: AbortSignal,
): Promise<CompanySearchResult> {
  return getJson<CompanySearchResult>('/api/companysearch', { name, includeCoordinates }, signal);
}
